import {useCallback, useMemo, useState} from "react";
import {InputField, SelectField, SelectUserAll} from "~/components/Forms";
import {StatusLabel} from "~/components";
import {useUtilities} from "~/hooks";

const STATUS_OPTIONS = [
	{value: '', label: 'Tất cả trạng thái'},
	{value: 'doing', label: 'Đang thực hiện'},
	{value: 'done', label: 'Đã thực hiện'},
	{value: 'paused', label: 'Tạm dừng'},
	{value: 'cancelled', label: 'Hủy'},
];

function MarketingProjectSearchBar({filter, onChange}) {

	const {utilities} = useUtilities();

	const [optionsUser, setOptionsUser] = useState([{value: '', label: 'Tất cả'}]);

	const serviceOptions = useMemo(() => {
		return [{value: '', label: 'Tất cả dịch vụ'}, ...Object.entries(utilities.services || {})
			.filter(([, v]) => v.channel === 'marketing')
			.map(([key, value]) => ({
				value: key,
				label: <StatusLabel small type={value.color}>{value.label}</StatusLabel>
			}))];
	}, [utilities.services]);

	const handleKeyword = useCallback((value) => { if (onChange) onChange('keyword', value); }, [onChange]);
	const handleService = useCallback((value) => { if (onChange) onChange('service', value); }, [onChange]);
	const handleStatus = useCallback((value) => { if (onChange) onChange('status', value); }, [onChange]);
	const handleAssign = useCallback((value) => { if (onChange) onChange('assignId', value); }, [onChange]);

	return (
		<div className="search-bar">
			<div className="container">
				<form className="form" autoComplete="off">
					<InputField value={filter.keyword} name="keyword" placeholder="Tìm tên dự án / website" onChange={(e) => handleKeyword(e?.target ? e.target.value : e)} />
					<SelectField value={filter.service} placeholder="Dịch vụ" options={serviceOptions} onChange={handleService} />
					<SelectField value={filter.status} placeholder="Trạng thái" options={STATUS_OPTIONS} onChange={handleStatus} />
					<SelectUserAll value={filter.assignId} placeholder="Nhân viên kỹ thuật" department="marketingTechnical" options={optionsUser} setOptions={setOptionsUser} onChange={handleAssign} />
				</form>
			</div>
		</div>
	)
}

export default MarketingProjectSearchBar;
